if (!customElements.get('kit-product-configurator')) {
  customElements.define('kit-product-configurator', class KitProductConfigurator extends HTMLElement {
    connectedCallback() {
      this.productForm = this.closest('product-form');
      this.form = this.closest('form');
      if (!this.productForm || !this.form) return;

      this.toggle = this.querySelector('[data-personalization-toggle]');
      this.body = this.querySelector('[data-personalization-body]');
      this.summary = this.querySelector('[data-personalization-summary]');
      this.message = this.querySelector('[data-kit-message]');
      this.file = this.querySelector('[data-personalization-file]');
      this.text = this.querySelector('[data-personalization-text]');
      this.notes = this.querySelector('[data-personalization-notes]');
      this.typeInputs = [...this.querySelectorAll('[data-personalization-type]')];

      this.toggle?.addEventListener('change', () => this.sync());
      this.typeInputs.forEach((input) => input.addEventListener('change', () => this.sync()));
      this.file?.addEventListener('change', () => {
        const label = this.querySelector('[data-file-name]');
        if (label) label.textContent = this.file.files[0]?.name || 'Alege imaginea';
      });
      this.form.addEventListener('submit', (event) => this.intercept(event), true);
      this.sync();
    }

    get personalizationType() {
      return this.typeInputs.find((input) => input.checked)?.value || 'Mesaj';
    }

    sync() {
      const enabled = Boolean(this.toggle?.checked);
      if (this.body) this.body.hidden = !enabled;
      if (this.summary) this.summary.value = enabled ? `Da — ${this.personalizationType}` : 'Nu';

      const needsText = enabled && this.personalizationType !== 'Imagine';
      const needsFile = enabled && this.personalizationType !== 'Mesaj';
      const textWrap = this.querySelector('[data-personalization-text-wrap]');
      const fileWrap = this.querySelector('[data-personalization-file-wrap]');
      if (textWrap) textWrap.hidden = enabled && !needsText;
      if (fileWrap) fileWrap.hidden = !needsFile;
      if (this.text) this.text.required = needsText;
      if (this.file) this.file.required = needsFile;
      this.hideMessage();
    }

    validate() {
      const missingSelect = [...this.querySelectorAll('[data-kit-required]')].find((field) => !field.value);
      if (missingSelect) {
        missingSelect.focus();
        const labels = [...this.querySelectorAll('[data-kit-required]')].map((field) =>
          field.name.includes('robă') ? 'mărimea robei' : 'mărimea tocii'
        );
        this.showMessage(`Alege ${labels.join(' și ')} înainte de adăugarea în coș.`);
        return false;
      }
      if (!this.toggle?.checked) return true;
      if (this.dataset.personalizationAvailable !== 'true' || !this.dataset.personalizationVariantId) {
        this.showMessage('Personalizarea nu este disponibilă momentan. Debifează opțiunea și adaugă kitul fără personalizare.');
        return false;
      }
      if (this.text?.required && !this.text.value.trim()) {
        this.text.focus();
        this.showMessage('Scrie mesajul dorit pe tocă.');
        return false;
      }
      if (this.file?.required && !this.file.files.length) {
        this.file.focus();
        this.showMessage('Alege imaginea pentru personalizarea tocii.');
        return false;
      }
      return true;
    }

    async intercept(event) {
      if (this.bypass) {
        this.bypass = false;
        return;
      }
      if (!this.validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!this.toggle?.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      this.busy = true;
      this.productForm.classList.add('m-spinner-loading');
      const submitter = event.submitter || this.form.querySelector('[name="add"]');

      try {
        const data = new FormData();
        data.append('id', this.dataset.personalizationVariantId);
        data.append('quantity', this.form.querySelector('[name="quantity"]')?.value || '1');
        data.append('properties[Tip personalizare]', this.personalizationType);
        if (this.personalizationType !== 'Imagine' && this.text?.value.trim()) {
          data.append('properties[Text personalizare]', this.text.value.trim());
        }
        if (this.personalizationType !== 'Mesaj' && this.file?.files[0]) {
          data.append('properties[Grafică personalizare]', this.file.files[0]);
        }
        if (this.notes?.value.trim()) data.append('properties[Observații]', this.notes.value.trim());
        data.append('properties[Pentru produs]', document.querySelector('.m-product-title')?.textContent.trim() || 'Kit de absolvire');

        const response = await fetch(`${window.MinimogSettings?.routes?.cart_add_url || '/cart/add.js'}`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: data
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Personalizarea nu a putut fi adăugată.');

        this.bypass = true;
        this.hideMessage();
        if (submitter && this.form.requestSubmit) this.form.requestSubmit(submitter);
        else this.form.submit();
      } catch (error) {
        this.showMessage(error.message || 'A apărut o eroare. Încearcă din nou.');
      } finally {
        this.busy = false;
        this.productForm.classList.remove('m-spinner-loading');
      }
    }

    showMessage(text) {
      if (!this.message) return;
      this.message.textContent = text;
      this.message.hidden = false;
      this.message.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    hideMessage() {
      if (this.message) this.message.hidden = true;
    }
  });
}
